import { $t } from '@previo/core'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum ThreadStatusId {
  NEW = 0,
  ACTIVE = 1,
  RESOLVED = 2,
}

export class ThreadStatus extends Codebook<ThreadStatusId> {
  static readonly NEW = new ThreadStatus(
    ThreadStatusId.NEW,
    () => $t('threadStatus.new'),
    Color.INFO,
  )
  static readonly ACTIVE = new ThreadStatus(
    ThreadStatusId.ACTIVE,
    () => $t('threadStatus.active'),
    Color.WARNING,
  )
  static readonly RESOLVED = new ThreadStatus(
    ThreadStatusId.RESOLVED,
    () => $t('threadStatus.resolved'),
    Color.POSITIVE,
  )

  private constructor(
    public readonly id: ThreadStatusId,
    public readonly name: () => string,
    public readonly color: Color,
  ) {
    super(id)
  }
}
